import React from 'react';

import { ReactComponent as CloseIcon } from 'images/cross-icon.svg';
import useBodyOverflow from 'hooks/useBodyOverflow';
import { createPortal } from 'react-dom';

import styles from './Modal.module.scss';

interface ModalProps {
  children: JSX.Element;
  title?: string;
  usePortal?: boolean;
  closeModal: () => void;
}

const Modal = ({ children, closeModal, title, usePortal = false }: ModalProps) => {
  useBodyOverflow(true);
  const content = (
    <>
      <div className={styles.container}>
        {title && <h2 className={styles.title}>{title}</h2>}
        <CloseIcon onClick={closeModal} className={styles.closeIcon} />
        {children}
      </div>

      <div className={styles.backdrop} />
    </>
  );
  if (!usePortal) return content;

  return createPortal(content, document.getElementById('modal-root')!);
};

export default Modal;
